module.exports = __webpack_public_path__ + "img/hk1_global_quotaIcon.f6a50df3.png";